import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Building2, Inbox, Newspaper, CheckCircle2, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Dashboard() {
  const { user } = useAuth();
  const { data: stats } = useQuery({ queryKey: ["stats"], queryFn: async () => (await api.get("/admin/stats")).data });
  const { data: leads = [] } = useQuery({ queryKey: ["recent-leads"], queryFn: async () => (await api.get("/admin/leads")).data });

  const cards = [
    { label: "Immobili totali", value: stats?.properties ?? "—", sub: `${stats?.properties_published ?? 0} pubblicati`, icon: Building2, to: "/admin/immobili" },
    { label: "Lead totali", value: stats?.leads ?? "—", sub: `${stats?.leads_new ?? 0} nuovi`, icon: Inbox, to: "/admin/lead" },
    { label: "Nuove richieste", value: stats?.leads_new ?? "—", sub: "da contattare", icon: CheckCircle2, to: "/admin/lead" },
    { label: "Articoli blog", value: stats?.posts ?? "—", sub: "pubblicati", icon: Newspaper, to: "/admin/blog" },
  ];

  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-[#1B2A41]">Ciao, {user?.name || "Titolare"} 👋</h1>
      <p className="text-[#566476] mt-1">Ecco una panoramica del tuo studio.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="bg-white rounded-2xl p-6 border border-[#DCE6EF] hover:shadow-lg transition-shadow" data-testid={`stat-${c.label}`}>
            <c.icon className="w-6 h-6 text-[#2472C8]" />
            <div className="font-mono text-4xl font-semibold text-[#1B2A41] mt-4">{c.value}</div>
            <div className="text-sm font-medium text-[#1B2A41] mt-1">{c.label}</div>
            <div className="text-xs text-[#8695A6]">{c.sub}</div>
          </Link>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-[#DCE6EF] mt-8">
        <div className="flex items-center justify-between p-6 border-b border-[#EAF0F6]">
          <h2 className="font-heading font-semibold text-[#1B2A41] text-lg">Ultime richieste</h2>
          <Link to="/admin/lead" className="text-[#2472C8] font-semibold text-sm flex items-center gap-1">Vedi tutte <ArrowRight className="w-4 h-4" /></Link>
        </div>
        {leads.length ? (
          <div className="divide-y divide-[#EAF0F6]">
            {leads.slice(0, 6).map((l) => (
              <div key={l.id} className="p-4 sm:px-6 flex items-center justify-between gap-4">
                <div className="min-w-0">
                  <div className="font-medium text-[#1B2A41] truncate">{l.name} <span className="text-xs font-mono text-[#8695A6]">· {l.kind}</span></div>
                  <div className="text-sm text-[#566476] truncate">{l.email} · {l.phone}</div>
                </div>
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full shrink-0 ${l.status === "Nuovo" ? "bg-[#2472C8]/10 text-[#2472C8]" : l.status === "Chiuso" ? "bg-[#166534]/10 text-[#166534]" : "bg-[#854D0E]/10 text-[#854D0E]"}`}>{l.status}</span>
              </div>
            ))}
          </div>
        ) : <div className="p-8 text-center text-[#8695A6]">Nessuna richiesta ricevuta.</div>}
      </div>
    </div>
  );
}
